<template>
  <a-modal
    title="Tipificación para el resultado de un Predictivo No Contacto"
    centered
    :visible="visible"
    :bodyStyle="{ padding: '30px 45px' }"
    :width="650"
    @cancel="handleCancel"
  >
    <p>
      Nuestra estrategia de tipo predictivo necesita guardar las equivalencias del tipo de grupo “No
      contacto”. Es importante configurar un resultado para cada uno de ellas.
    </p>

    <a-alert
      v-if="resultsOptions.length === 0"
      class="warning__alert"
      message="Crea un tipo de grupo No contacto con al menos 1 resultado."
      type="warning"
      show-icon
    />

    <section>
      <div class="column">
        <div class="column__title">
          <h2>Equivalencias de {{ ProductName }}</h2>
        </div>

        <a-input
          v-for="equivalency in equivalencies"
          :key="`scorecloud-${equivalency?.atk_state?.id}`"
          :placeholder="equivalency?.atk_state?.name"
          disabled
        />
      </div>

      <div class="column">
        <div class="column__title">
          <h2>Resultados de {{ entityName }}</h2>
        </div>

        <a-form ref="formRef" :model="formState" class="equivalencies-form">
          <a-form-item
            v-for="equivalency in equivalencies"
            :key="`entity-${equivalency?.atk_state?.id}`"
          >
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              :class="{
                warning__border:
                  isNCEquivalenciesIncomplete && !formState?.[equivalency?.atk_state?.id],
              }"
              v-model:value="formState[equivalency.atk_state.id]"
              placeholder="Seleccionar resultado"
              :options="resultsOptions"
              @change="handleSelectChange"
            />
          </a-form-item>
        </a-form>
      </div>
    </section>

    <template #footer>
      <a-button key="back" @click="handleCancel">Cancelar</a-button>

      <a-tooltip placement="topRight" arrowPointAtCenter>
        <template #title v-if="disabledButton">
          Todas las equivalencias deben tener un resultado para guardar cambios.
        </template>

        <a-button
          key="submit"
          type="primary"
          :class="{ disabledButton }"
          :disabled="disabledButton"
          @click="handleOk"
        >
          Guardar cambios
        </a-button>
      </a-tooltip>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, computed, ref, reactive } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { groupTypes } from "@/app/entities/utils/enums";
import { message } from "ant-design-vue";
import { ProductName } from "@/app/shared/utils/constants";

import { createNoContactEquivalencies } from "@/app/entities/services";

export default defineComponent({
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    entityName: {
      required: true,
      type: String,
    },
    equivalencies: {
      required: [],
      type: Array,
    },
    isNCEquivalenciesIncomplete: {
      required: true,
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();

    const formRef = ref(null);
    const disabledButton = ref(true);

    // const formState = computed(() =>
    //   Object.fromEntries(
    //     props.equivalencies?.map((equivalency) => [equivalency?.atk_state?.id, equivalency?.result])
    //   )
    // );

    const formState = reactive({});

    props.equivalencies?.forEach((e) => {
      formState[e?.atk_state?.id] = e?.result;
    });

    const noContactGroups = computed(() =>
      store.getters["getTypificationTree"]?.filter((group) => group?.group_type === groupTypes.NC)
    );

    const noContactResults = computed(() =>
      noContactGroups.value?.flatMap((group) => group?.results)
    );

    const resultsOptions = computed(() =>
      noContactResults.value?.map((result) => ({ value: result?.id, label: result?.name }))
    );

    const handleSelectChange = () => {
      const results = Object.values(formState);

      // disabledButton.value = results.some((result) => result === null);
      disabledButton.value = results.length !== 5;
    };

    const handleOk = () => {
      formRef.value.validate().then(async () => {
        const portfolioId = Number(route.params.id);
        const body = [];

        for (const atk_state in formState) {
          body.push({
            atk_state: Number(atk_state),
            result: formState[atk_state],
          });
        }

        await createNoContactEquivalencies(portfolioId, body);
        handleCancel();
        message.success("Tus cambios se han guardado correctamente");
        emit("save");
      });
    };

    const handleCancel = () => {
      emit("close");
    };

    return {
      formRef,
      formState,
      resultsOptions,
      disabledButton,
      handleSelectChange,
      handleOk,
      handleCancel,
      ProductName,
    };
  },
});
</script>

<style lang="sass" scoped>
p
  color: $gray-8

.warning
  &__border
    border: 1px solid $orange-6
    border-radius: 2px

  &__alert
    margin-bottom: 14px
    color: $gray-8 !important

section
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 12px

  h2
    color: $gray-9
    margin: 0
    font-size: 14px

.column, .equivalencies-form
  display: grid
  gap: 8px

  &__title
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis

.ant-form-item
  margin-bottom: 0 !important

.disabledButton
  margin-left: 8px
</style>

<style>
.ant-alert-message {
  color: inherit !important;
}
</style>
